import React, { useState, useEffect } from 'react';
import { initGA, trackPageView } from '../utils/analytics';
import { useLocation } from 'react-router-dom';

const EurodressageCookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [cookiesAccepted, setCookiesAccepted] = useState(null);
  const location = useLocation();

  // Check if cookies were previously accepted
  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (consent === 'accepted') {
      setCookiesAccepted(true);
      initGA();
      setShowBanner(false);
    } else if (consent === 'declined') {
      setCookiesAccepted(false);
      setShowBanner(false);
    } else {
      // No consent given yet, show banner
      setShowBanner(true);
    }
  }, []);

  // Track page views when cookies are accepted
  useEffect(() => {
    if (cookiesAccepted) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, cookiesAccepted]);

  const handleCookieAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setCookiesAccepted(true);
    setShowBanner(false);
    initGA();
    // Track the current page view
    trackPageView(location.pathname + location.search);
  };

  const handleCookieDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setCookiesAccepted(false);
    setShowBanner(false);
  };

  // Don't show banner if user has already made a choice
  if (!showBanner) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#333',
      color: 'white',
      padding: '20px',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        flex: 1,
        marginRight: '20px',
        fontSize: '14px',
        lineHeight: '1.5'
      }}>
        We use cookies to enhance your experience and analyze our traffic. By continuing to use this site, you consent to our use of cookies.{' '}
        <a 
          href="/cookie-policy" 
          style={{color: '#4CAF50', textDecoration: 'underline'}}
        >
          Cookie Policy
        </a>
      </div>
      
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button
          onClick={handleCookieDecline}
          style={{
            backgroundColor: 'transparent',
            color: '#ccc',
            border: '1px solid #666',
            padding: '12px 24px',
            cursor: 'pointer',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#666';
            e.target.style.color = 'white';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#ccc';
          }}
        >
          Decline
        </button>
        
        <button
          onClick={handleCookieAccept}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            cursor: 'pointer',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#45a049';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#4CAF50';
          }}
        >
          Accept All Cookies
        </button>
      </div>
    </div>
  );
};

export default EurodressageCookieBanner;
